import React, { useEffect, useRef, useState } from "react";
import { Button, Steps, message, Space, Row } from "antd";
import { SaveButton, ModalComponent, trans } from "@comps/components"
import { makeRequest, makeRequestStateless } from "@utils/helpers";
import { createDataReq, updateDataReq, getRelatedDataReq, getCompanyRelatedDataReq } from "../requests";
import dayjs from "dayjs";

import { Commons } from "../../constants";
import FilterSelectEmployees from "@mods/common/FilterSelectEmployees";
import { getPreviewReq } from "@mods/common/requests";
import CreateStepOne from "./CreateStepOne";
import CreatePreview from "./CreatePreview";
import PreparePolicyEffects from "./PreparePolicyEffects";
import AttendanceRulePreview from "./AttendanceRulePreview";
import {
  attendancePlannerDependencyMap,
  attendancePlannerSetupTypes,
} from "../policyDependencyConfig";
import "./attendancePolicyPlannerModal.css";
const formName = "createCompanyRoaster";

const CreateAttendancePolicyPlanner = (props) => {
  //========initial child states===============

  //============================
  const [, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [companyRelatedData, setCompanyRelatedData] = useState([]);
  const [selectedEmployments, setEmployments] = useState([]);
  const [previewEmployment, setPreviewEmployments] = useState([]);
  const [previewData, setPreviewData] = useState([]);
  //------------intitial steps state---------
  const [firstStepData, setFirstStepData] = useState(null);
  const [relatedData, setRelatedData] = useState({})
  const [currentStep, setCurrent] = useState(0);
  const [childComponent, setChildComponent] = useState(null)
  const [preview, setPreview] = useState(null)

  const [preEmployeesFilter, setPreEmployeesFilter] = useState({})
  const [unSelectedEmployees, setUnSelectedEmployees] = useState([])
  const [selectedEmployees, setSelectedEmployees] = useState([])
  const previewOptionsRef = useRef({})
  //=======================================
  //=======================================
  useEffect(() => {
    getRemoteData()
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (props.record?.id) {
      initializeEditData(props.record);
    }
    // eslint-disable-next-line
  }, [props.record?.id]);

  const getRemoteData = () => {
    makeRequestStateless(getRelatedDataReq, null, ongetRelatedDataReq, null);
    makeRequestStateless(getCompanyRelatedDataReq, null, ongetCompanyRelatedDataReq, null);
  }
  const ongetCompanyRelatedDataReq = (response) => {
    setCompanyRelatedData(response)
  }
  const ongetRelatedDataReq = (response) => {
    setRelatedData(response)
  }

  const initializeEditData = (record) => {
    const data = {
      ...record,
      date: record.date ? dayjs(record.date) : null,
    };

    setFirstStepData(data);
    setCurrent(1);
    getPreview({ id: record.id }, { stayOnStep: true });
  }

  const onDependencyCompleted = (data) => {
    setChildComponent(null);
    if (data && data.length !== 0) {
      getRemoteData();
    }
  }

  const onDependencySuccess = () => {
    getRemoteData();
  }

  const openCreateSetup = (setupKey) => {
    const dependency = attendancePlannerSetupTypes.find((item) => item.key === setupKey);
    if (!dependency) {
      return;
    }

    const Component = dependency.createComponent;
    setChildComponent(<Component onCompleted={ onDependencyCompleted } onSuccess={ onDependencySuccess } />);
  }

  const openCreateDependency = (dependencyKey) => {
    const dependency = attendancePlannerDependencyMap[dependencyKey];
    makeRequestStateless(dependency.requestFn, { page: 1 }, (response) => {
      const Component = dependency.createComponent;
      setChildComponent(
        <Component
          onCompleted={ onDependencyCompleted }
          onSuccess={ onDependencySuccess }
          allData={ response }
        />
      );
    }, onError);
  }

  const openRulePreview = (dependency, rule) => {
    if (rule?.slabs) {
      setPreview({
        type: "rule",
        dependency,
        record: rule,
        relatedData,
      });
      return;
    }

    makeRequestStateless(dependency.requestFn, { page: 1 }, (response) => {
      const list = response[dependency.responseKey]?.data || [];
      const record = list.find((item) => `${item.id}` === `${rule.id}`) || rule;
      setPreview({
        type: "rule",
        dependency,
        record,
        relatedData: { ...relatedData, ...response },
      });
    }, onError);
  }

  const openPackagePreview = (policyPackage) => {
    setPreview({
      type: "package",
      record: policyPackage,
      relatedData,
    });
  }

  const openViewDependency = (dependencyKey, selectedId) => {
    if (!selectedId) {
      message.info("Please select a policy first.");
      return;
    }

    const dependency = attendancePlannerDependencyMap[dependencyKey];
    makeRequestStateless(dependency.requestFn, { page: 1 }, (response) => {
      const list = response[dependency.responseKey]?.data || [];
      const relatedList = relatedData[dependency.relatedListKey] || [];
      const record = list.find((item) => `${item.id}` === `${selectedId}`)
        || relatedList.find((item) => `${item.id}` === `${selectedId}`);

      if (!record) {
        message.warning("Selected policy could not be loaded.");
        return;
      }

      setPreview({
        type: "rule",
        dependency,
        record,
        relatedData: { ...relatedData, ...response },
      });
    }, onError);
  }

  const openEditDependency = (dependencyKey, selectedId) => {
    if (!selectedId) {
      message.info("Please select a policy first.");
      return;
    }

    const dependency = attendancePlannerDependencyMap[dependencyKey];
    makeRequestStateless(dependency.requestFn, { page: 1 }, (response) => {
      const list = response[dependency.responseKey]?.data || [];
      const relatedList = relatedData[dependency.relatedListKey] || [];
      const record = list.find((item) => `${item.id}` === `${selectedId}`)
        || relatedList.find((item) => `${item.id}` === `${selectedId}`);

      if (!record) {
        message.warning("Selected policy could not be loaded.");
        return;
      }

      const Component = dependency.updateComponent;
      setChildComponent(
        <Component
          onCompleted={ onDependencyCompleted }
          allData={ response }
          record={ record }
          disabled={ false }
        />
      );
    }, onError);
  }
  //==============================Save all Data=========================================
  const onSubmit = () => {
    //setSaveLoader(true)
    const obj = { ...firstStepData, company_id: localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1, employment_ids: selectedEmployments, date: firstStepData.date.format('YYYY-MM-DD') }
    let payload = { policy_planer: obj };
    if (props.record?.id) {
      payload = { id: props.record.id, policy_planer: { ...obj, id: props.record.id } };
      makeRequest(setLoader, updateDataReq, payload, onSuccess, onError);
      return;
    }
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {

    setSaveLoader(false)
    if (data.errors !== undefined && data.errors.length > 0) {
      message.error(`${data.errors[0].reason}`);
      return;
    }
    else {
      message.success("Saved successfully");
    }
    props.onCompleted(data.policy_planers.data);
    props.onSuccess(data)
  }
  const onError = (err, res) => {

    message.error(res.response.data.message);
  }
  //=================Submit First Step 1==============================================
  const getStepOneData = (data, dates) => {
    const nextData = { ...(firstStepData || {}), ...data };
    setFirstStepData(nextData);
    if (data.for_all !== undefined && data.for_all) {
      getPreview(buildPreviewPayload(nextData, selectedEmployments), { goToReview: true })
    }
    else {
      setCurrent(2)
    }
  }
  //=====================On Submit Second Step===========================
  const setSelectedEmploymentsIds = (employments) => {
    setEmployments(employments.employment_ids)
    let empIds = employments.employment_ids;
    const obj = buildPreviewPayload(firstStepData, empIds)
    getPreview(obj, { goToReview: true })
    setCurrent(3)
  }

  const buildPreviewPayload = (data, employmentIds) => {
    const { id, employments, ...policyData } = data || {};
    return {
      ...policyData,
      company_id: localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1,
      employment_ids: employmentIds,
    };
  }

  const getPreview = (data, options = {}) => {
    previewOptionsRef.current = options;
    let payload = { moduleName: 'policyPlaners', policy_planer: data };
    makeRequest(setLoader, getPreviewReq, payload, onGetPreview, null);
  }
  const onGetPreview = (response) => {
    if (response) {
      setPreviewData(response.policy_planer)
      setPreviewEmployments(response.policy_planer.employments)
      const options = previewOptionsRef.current || {};
      if (props.record?.id) {
        const employments = response.policy_planer.employments || [];
        setEmployments(employments.map((employment) => employment.id));
        setSelectedEmployees(employments);
        if (options.stayOnStep) {
          return;
        }
      }
      if (options.goToReview || (response.policy_planer.for_all !== undefined && response.policy_planer.for_all)) {
        setCurrent(3)
      }
    }
  }
  const onCancel = () => {
    props.onCompleted(false);
  }
  const onBack = () => {
    setCurrent(currentStep - 1)
  }

  //================================Main Modal Component==================================
  return (
    <ModalComponent top={ 20 } width={ 1200 } maskClosable={ false } className="attendance-policy-planner-modal"
      mainTitle={ trans(Commons[props.record?.id ? 'update' : 'create']) } subTitle="Employee policy package"
      visible={ true } onCancel={ () => props.onCompleted(false) } footer={ '' }>
      <AttendanceRulePreview
        open={ Boolean(preview) }
        preview={ preview }
        onClose={ () => setPreview(null) }
      />
      <div className="attendance-policy-planner-steps">
        <Steps
          className="attendance-policy-planner-steps__control"
          current={ currentStep }
        >
          <Steps.Step title="Salary effects" description="Prepare deduction and earning effects" />
          <Steps.Step title="Attendance rules" description="Create the policy rules" disabled={ false } />
          <Steps.Step title="Employees" description="Choose who gets this policy" disabled={ !firstStepData || firstStepData?.for_all } />
          <Steps.Step title="Final review" description="Check and submit" disabled={ !previewData } />
        </Steps>
      </div>
      { childComponent }


      { currentStep === 0 ?
        <PreparePolicyEffects
          relatedData={ relatedData }
          onCreateSetup={ openCreateSetup }
          onPreviewRule={ openRulePreview }
          onPreviewPackage={ openPackagePreview }
          onNext={ () => setCurrent(1) }
        />
        : currentStep === 1 ?
        <CreateStepOne
          relatedData={ relatedData }
          initialValues={ firstStepData }
          response={ getStepOneData }
          onCancel={ onCancel }
          onCreateDependency={ openCreateDependency }
          onEditDependency={ openEditDependency }
          onViewDependency={ openViewDependency }
          onBack={ () => setCurrent(0) }
        />
        : currentStep === 2 ?
          <FilterSelectEmployees setSelectedEmploymentsIds={ setSelectedEmploymentsIds } initialValues={ preEmployeesFilter } companyRelatedData={ companyRelatedData } onCancel={ onCancel } onBack={ onBack }
            employment_ids={ selectedEmployments }
            moduleName='companyRoaster' selected={ selectedEmployees } unSelected={ unSelectedEmployees } preFilters={ preEmployeesFilter } setSelected={ setSelectedEmployees } setUnselected={ setUnSelectedEmployees } setPrefilters={ setPreEmployeesFilter }
          />
          : currentStep === 3 && previewData ?
            <CreatePreview record={ previewData } relatedData={ relatedData } /> : '' }


      {
        currentStep === 3 ?
          <Row justify="end" className="attendance-policy-planner-footer">
            <Space>
              <Button className="button-back" onClick={ () => setCurrent(firstStepData?.for_all ? 1 : 2) } disabled={ currentStep > 0 ? false : true }>
                <span style={ { color: "#4079FC" } }>Back</span>
              </Button>
              <SaveButton className="button-next" loading={ saveLoader } form={ formName } key="create_button" onClick={ () => onSubmit() } disabled={ previewData ? false : true } />
            </Space>
          </Row>
          : ''
      }
    </ModalComponent>
  )
}
export default CreateAttendancePolicyPlanner
